import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListEmailTemplates from '../../components/smtp/list-email-templates.component';

const EmailTemplatesView = () => {
  const pageTitle = 'Settings / Email Templates';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListEmailTemplates />
    </AppLayout>
  );
};

export default EmailTemplatesView;
